var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1517_5245",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1517_5245",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAD8klEQVR4nO2dvWsVSxiHn2jEoBZ6exEEb6uNggr3dmr8KLW8Ctra+QfYa6O2Il6ri5XlFS0UFAQFG7UJREkigoUKKgRijMWZE47r7M7u2d3xfcPvgSE5uzPvPsff7mQ/kiMIIYQQQgghhB2OAQvAitE2D0yvIe8k8wbkU21uDXkDMFG2Igz0QPE9ePUGYF1uC1HNZIO+VUdTTpoeAa68dYQYQ4EYQ4EYQ4EYQ4EYQ4EYQ4EYQ4EYQ4EYQ4EYQ4EYY5xAjgKvyXer+jVjPj9YI96rFDcwZC7jmxq2hRpe3r0BTVmuKEt0GpiNrO+rzQJHanh59waaPTG0+lwh9cTQizegKcscCsQYCsQYCsQYCsQYuQI5AbwN7XimbXaBKe9a58012Ai8H6nzPizry8urd/8FAqcitU62qJcrkNze/RcI3I3U+r9FvVyB5PbuvwCwHfgWqbUM7BizZo5Afoc30P8P9bPA+pLtnul5220w6d12T1sHvInUGbY54m+6rZdX794LHC6M/xra6LLDPXh59Qba3e39AzgP7AS2hdfbRtpUof+t8PWfwvJF4ONI+xC+zgJXw/dNvLx6J0klej/Sp6r9FVqTMffG8PLqnSRVoHgYV7WXDPaICeBVg3FfxvDy6p0kVeBGQmoReAc8AHaPjNsDPAzrFhM1ro/h5dU7SarABuBmpN934EKD7VwIY4p1boZtNPXy6p2kToEJ4GKk7wpwherrnNTYsh96bQOx6p2kSYFzwFJkzOWKMZcj/ZdCrTZeXr2TNC1wFPhcGLNM/CJqMqwb7fs51Gjr5dW7lwLThTFfib+x9fx6tlP3t/y6DsSKN9D9vaythddPGexRU8BpBhdXU2HZ08TYnJjx7jqQA4XXj4D9wHMGZx//Ai+Av4HHhb77O3ZpggvvcQ79Z4UxT/h1zh3O0U8Ky5515OXVu/MCm4mfsdRtS8CWDry8egPdTln7qP6ojtQ/0CSwt0Ofupjy7jKQgxXr3gCHGNykm6noV5zLc+DGu+mhfycyZhm4xs+H9JawLDZH3+nAy6t35wVuF/rPMNizyhjudaNj/uvAy6t35wX+ZHCa+Am4BGyqMWZT6PspjN3VgZdXb0B/H5KTWl763V5jKBBjKBBjKBBjKBBj6JMc7HuvUnbebP0TEbx6A5qyXFGWqPVPRPDqDehKPSe1vDRlGUOBGEOBGEPXIfa9Vyk7K7B+Pu/VG9CU5YqyRK2fz3v1BnQdkpNaXpqyjKFAjKFAjKFAjKFAjKFAjKFAjKFAjKFAjNHk/8Itvdw3jitvHSHGqApkoWKdFeYjy7x6J5kOA3M/Q6jb5vj5bqp3byGEEEIIIYT4LfwARY6QwVmwK34AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElective);
export default __webpack_public_path__ + "static/media/Elective.76966c609d8880000f73d63f565da1d7.svg";
export { ForwardRef as ReactComponent };